module.exports = __webpack_public_path__ + "res/19-img_game_bg.30daee2e235167b49df0c52a5cea67e1.png";